<template>
  <div id="testimonials-area" class="container" data-cue="slideInUp">
    <div class="row">
      <div class="col-xxl-6 offset-xxl-3 col-xl-6 offset-xl-3 px-xxl-5">
        <h2 class="section-title text-center mb-45">
          What Couples Say About Mazii
        </h2>
      </div>
    </div>
  </div>

  <swiper
    :loop="false"
    :speed="1400"
    :spaceBetween="25"
    :grabCursor="true"
    :autoplay="{
      delay: 4000,
      disableOnInteraction: true,
    }"
    :breakpoints="{
      0: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 1.4,
      },
      768: {
        slidesPerView: 1.9,
      },
      992: {
        slidesPerView: 2.4,
      },
      1200: {
        slidesPerView: 3.3,
      },
      1400: {
        slidesPerView: 4.5,
      },
    }"
    :modules="modules"
    class="home_one-testimonial-slider-one mb-30"
  >
    <swiper-slide v-for="testimonial in testimonials" :key="testimonial.id">
      <div class="testimonial-card bg-magnolia round-10">
        <ul class="rating list-style">
          <li>
            <img src="../../assets/img/icons/star-fill.svg" alt="Image" />
          </li>
          <li>
            <img src="../../assets/img/icons/star-fill.svg" alt="Image" />
          </li>
          <li>
            <img src="../../assets/img/icons/star-fill.svg" alt="Image" />
          </li>
          <li>
            <img src="../../assets/img/icons/star-fill.svg" alt="Image" />
          </li>
          <li>
            <img src="../../assets/img/icons/star-line.svg" alt="Image" />
          </li>
        </ul>
        <p>
          {{ testimonial.description }}
        </p>
        <div class="d-flex align-items-center justify-content-between">
          <h6>{{ testimonial.name }}</h6>
          <img src="../../assets/img/icons/quote.svg" alt="Image" />
        </div>
      </div>
    </swiper-slide>
  </swiper>
</template>

<script>
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";

export default {
  name: "WhatOurCustomerSays",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      testimonials: [
        {
          id: 1,
          description:
            "Mazii has completely transformed how my boyfriend and I stay connected. Seeing his photos on my home screen makes me smile every day!",
          name: "Emma & Jake",
        },
        {
          id: 2,
          description:
            "The secret moments feature is our favorite! It adds so much fun and mystery to our relationship. We're obsessed with Mazii!",
          name: "Sarah & Michael",
        },
        {
          id: 3,
          description:
            "Long distance is hard, but Mazii makes it feel like we're always together. The widgets keep us connected throughout the day.",
          name: "Lily & David",
        },
        {
          id: 4,
          description:
            "We love how private and intimate Mazii feels. It's just for us two, and the anniversary reminders are so thoughtful!",
          name: "Alex & Jordan",
        },
        {
          id: 5,
          description:
            "The real-time sync is amazing! When I send a photo, it appears instantly on his widget. It's like magic for couples!",
          name: "Maya & Chris",
        },
        {
          id: 6,
          description:
            "Mazii brings back the excitement in our relationship. Every notification feels like a love letter. Highly recommend!",
          name: "Sophie & Ryan",
        },
        {
          id: 7,
          description:
            "The widget templates are beautiful and the app is so easy to use. Perfect for busy couples who want to stay close.",
          name: "Zoe & Nathan",
        },
      ],
    };
  },
  setup() {
    return {
      modules: [Autoplay],
    };
  },
};
</script>

<style lang="scss" scoped>
.home_one-testimonial-slider-one {
  .testimonial-card {
    padding: 25px;
    border-radius: 6px;
    p {
      margin: 15px 0 20px;
    }
    h6 {
      color: rgba(37, 27, 66, 0.7);
      font-size: 18px;
      font-weight: 500;
      line-height: 28px;
      margin-bottom: 0;
    }
    .rating {
      line-height: 1;
      li {
        line-height: 1;
        margin-right: -3px;
        i,
        img {
          color: #f3795d;
          margin-right: 5px;
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .home_one-testimonial-slider-one {
    padding: 0 12px;
  }
}

@media only screen and (min-width: 1400px) {
  .home_one-testimonial-slider-one {
    .testimonial-card {
      padding: 32px 30px 30px 35px;
    }
  }
}
</style>